export default "__VITE_ASSET__fb643ce1__"